import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import * as moment from "moment";

@Component({
  selector: 'Openpay-failure',
  templateUrl: './failure.component.html',
  styleUrls: ['./failure.component.scss']
})
export class FailureComponent implements OnInit {

  public errorTitle: string = "Lo sentimos, ocurrió un problema"
  public errorMessage: string = "Ha ocurrido un error"
  public callbackUrl: any = "#"
  public errorButtonCta: string = "Vuelve a intentarlo";

  private code: any

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.handleQueryParams()
    this.validateTimeOfCode()
  }

  handleQueryParams(){

    this.errorTitle = this.route.snapshot.queryParamMap.get("errorTitle") || "Lo sentimos, ocurrió un problema";
    this.errorMessage = this.route.snapshot.queryParamMap.get("errorMessage") ||"Ha ocurrido un error";
    this.errorButtonCta = this.route.snapshot.queryParamMap.get("errorButtonCta") || "Vuelve a intentarlo"
    this.callbackUrl = this.route.snapshot.queryParamMap.get("callbackUrl") || window.location.href;

    this.code = this.route.snapshot.queryParamMap.get("code")
  }

  private validateTimeOfCode = () => {
    if(!this.code){
      this.router.navigate(['not-found']).then()
      return
    }

    let codeValue = this.base64DecodeUnicode(this.code)

    let [time, place] = codeValue.split('-')

    if((moment().utc(true).valueOf() - (30 * 1000)) > +time){
      this.router.navigate(['not-found']).then()
    }

    if(place !== 'failure'){
      this.router.navigate(['not-found']).then()
    }

  }

  goToCallbackUrl() {
    window.location.href = this.callbackUrl.includes("http") ? this.callbackUrl : this.base64DecodeUnicode(this.callbackUrl);
  }

  base64DecodeUnicode (str){

    let percentEncodedStr = atob(str).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join('');


    return decodeURIComponent(percentEncodedStr);
  }

}
